import { useEffect, useState } from 'react';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

interface ToastProps {
  message: string;
  type?: ToastType;
  duration?: number;
  onClose: () => void;
}

const icons: Record<ToastType, string> = {
  success: 'ri-checkbox-circle-line',
  error: 'ri-error-warning-line',
  info: 'ri-information-line',
  warning: 'ri-alert-line',
};

const colors: Record<ToastType, string> = {
  success: 'text-emerald-400 bg-emerald-500/10 border-emerald-500/30',
  error: 'text-red-400 bg-red-500/10 border-red-500/30',
  info: 'text-cyan-400 bg-cyan-500/10 border-cyan-500/30',
  warning: 'text-yellow-400 bg-yellow-500/10 border-yellow-500/30',
};

const Toast = ({ message, type = 'info', duration = 3500, onClose }: ToastProps) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const show = setTimeout(() => setVisible(true), 10);
    const hide = setTimeout(() => {
      setVisible(false);
      setTimeout(onClose, 400);
    }, duration);
    return () => {
      clearTimeout(show);
      clearTimeout(hide);
    };
  }, [duration, onClose]);

  return (
    <div
      className={`flex items-center gap-3 px-4 py-3 rounded-2xl border backdrop-blur-xl text-sm font-medium shadow-2xl transition-all duration-400 ${colors[type]} ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'
      }`}
    >
      <i className={`${icons[type]} text-base`} />
      <span>{message}</span>
      <button onClick={onClose} className="ml-2 opacity-60 hover:opacity-100 cursor-pointer">
        <i className="ri-close-line" />
      </button>
    </div>
  );
};

export default Toast;
